// extracted by css-extract-rspack-plugin
export default {"originPath":"djdZFSszJcskJoru","originPaths":"RIjCMEnBpvcBVEmx","title":"voDhtoZ37e8wXMBo"};